<div class="page-wrapper">
  <app-breadcrumbs></app-breadcrumbs>
  <div class="about-banner content-wrapper" *ngIf="!pageRetrievalError"></div>
  <section>
    <div class="content-wrapper about-content-wrapper">
      <div class="header-background"></div>
      <app-page-retrieval-error
        *ngIf="pageRetrievalError"
      ></app-page-retrieval-error>
      <h1>{{ pageData.title }}</h1>
      <div class="separator"></div>
      <h2 class="subheading">{{ pageData.intro_heading }}</h2>
      <p class="about-intro">{{ pageData.intro }}</p>
      <div class="content">
        <h2 class="about-sections-heading">{{ pageData.sections_heading }}</h2>
        <div class="about-sections">
          <div
            class="about-section"
            *ngFor="let aboutSection of pageData.about_sections"
          >
            <h3
              class="about-section-heading"
              (click)="toggleAboutSection($event)"
            >
              {{ aboutSection.section_title }}
            </h3>
            <div class="about-section-content">
              <div class="about-section-content-inner">
                <app-render-markdown
                  [content]="aboutSection.section_text"
                ></app-render-markdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
